import { LANGUAGE, LOADING } from "../constants/ui";

export const getDefaultLanguage = () => {
  return localStorage.getItem("language") || "english";
};

export const setLoading = (payload) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload,
  });
};

export const setLanguage = (payload) => (dispatch) => {
  localStorage.setItem("language", payload);
  dispatch({
    type: LANGUAGE,
    payload,
  });
};
